<template lang="pug">
    .flex.items-start
        .flex.items-center.h-5
            input(type='checkbox' :id="'field_' + parameter.id" :name="'field_' + parameter.id" :checked='checked' @change='handleChange'
                class='focus:ring-indigo-500 h-6 w-6 text-indigo-600 border-gray-300 rounded')
        .ml-3.text-sm
            label.font-medium.text-gray-700(:for="'field_' + parameter.id")
                | {{ parameter.name }}
</template>

<script>
import store from 'js@/store'

export default {

    name: 'ItemFormGroupParameterCheckbox',

    store,

    props: {
        parameter: {
            type: Object,
        },

        value: {
            type: [String, Number],
        },

        error: {
            type: [Object, Boolean],
        },
    },

    data () {
        return {
            checked: !!Number(this.value),
            changed: false,
        }
    },

    watch: {
        value: {
            handler: function (newValue) {
                if (newValue) {
                    this.checked = (newValue !== '0')
                }
            },
        },
    },

    methods: {
        handleChange ($event) {
            let passedValue = ($event.target.checked) ? '1' : '0'
            this.$emit('input', passedValue)
        },
    },
}

</script>
